import { Link } from 'react-router-dom';
import { rankingCards } from '../../../mocks/ranking-cards';

export default function ComparisonTable() {
  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* ヘッダー */}
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <span className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-100 to-emerald-100 text-teal-700 px-4 sm:px-5 py-2 rounded-full text-xs sm:text-sm font-bold mb-4 sm:mb-6 shadow-sm">
            <i className="ri-bar-chart-grouped-line text-base sm:text-lg"></i>
            スペック比較
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-5 tracking-tight px-4">
            クレジットカード
            <br className="sm:hidden" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-emerald-600">比較一覧表</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-500 max-w-2xl mx-auto px-4">
            主要カードのスペックを一目で比較できます
          </p>
        </div>

        {/* テーブル */}
        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-xl overflow-hidden border border-gray-100">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[800px]">
              <thead>
                <tr className="bg-gradient-to-r from-teal-600 to-emerald-600">
                  <th className="px-4 sm:px-6 py-4 sm:py-5 text-left font-bold text-white whitespace-nowrap text-sm sm:text-base">カード名</th>
                  <th className="px-4 sm:px-6 py-4 sm:py-5 text-left font-bold text-white whitespace-nowrap text-sm sm:text-base">年会費</th>
                  <th className="px-4 sm:px-6 py-4 sm:py-5 text-left font-bold text-white whitespace-nowrap text-sm sm:text-base">還元率</th>
                  <th className="px-4 sm:px-6 py-4 sm:py-5 text-left font-bold text-white whitespace-nowrap text-sm sm:text-base">特徴</th>
                  <th className="px-4 sm:px-6 py-4 sm:py-5 text-center font-bold text-white whitespace-nowrap text-sm sm:text-base">詳細</th>
                  <th className="px-4 sm:px-6 py-4 sm:py-5 text-center font-bold text-white whitespace-nowrap bg-gradient-to-r from-orange-500 to-red-500 text-sm sm:text-base">申込</th>
                </tr>
              </thead>
              <tbody>
                {rankingCards.map((card, index) => (
                  <tr
                    key={card.id}
                    className={`border-b border-gray-100 hover:bg-teal-50/50 transition-colors ${
                      index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'
                    }`}
                  >
                    <td className="px-4 sm:px-6 py-5 sm:py-6">
                      <div className="flex items-center gap-2 sm:gap-3">
                        <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-gray-100 to-gray-50 rounded-xl flex items-center justify-center text-xs sm:text-sm font-bold text-gray-500 border border-gray-200 flex-shrink-0">
                          {index + 1}
                        </div>
                        <Link to={card.detailUrl} className="font-bold text-gray-900 whitespace-nowrap text-sm sm:text-base hover:text-teal-600 hover:underline transition-colors cursor-pointer">
                          {card.name}
                        </Link>
                      </div>
                    </td>
                    <td className="px-4 sm:px-6 py-5 sm:py-6">
                      <span className="text-gray-700 font-medium whitespace-nowrap text-sm sm:text-base">{card.annualFee}</span>
                    </td>
                    <td className="px-4 sm:px-6 py-5 sm:py-6">
                      <span className="inline-flex items-center gap-1 bg-gradient-to-r from-teal-50 to-emerald-50 text-teal-700 font-bold px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg whitespace-nowrap text-xs sm:text-sm">
                        <i className="ri-percent-line text-xs sm:text-sm"></i>
                        {card.returnRate}
                      </span>
                    </td>
                    <td className="px-4 sm:px-6 py-5 sm:py-6">
                      <span className="text-gray-600 text-sm sm:text-base">{card.mainBenefit}</span>
                    </td>
                    <td className="px-4 sm:px-6 py-5 sm:py-6 text-center">
                      <a
                        href={card.detailUrl}
                        className="inline-flex items-center gap-1 text-teal-600 hover:text-teal-700 font-semibold whitespace-nowrap cursor-pointer hover:gap-2 transition-all text-sm sm:text-base"
                      >
                        詳細
                        <i className="ri-arrow-right-line"></i>
                      </a>
                    </td>
                    <td className="px-4 sm:px-6 py-5 sm:py-6 text-center bg-gradient-to-r from-orange-50/50 to-red-50/50">
                      <a
                        href={card.officialUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center gap-1 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-bold px-4 sm:px-5 py-2 sm:py-2.5 rounded-xl transition-all whitespace-nowrap cursor-pointer shadow-md hover:shadow-lg text-xs sm:text-sm"
                      >
                        申込む
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          <div className="px-4 sm:px-6 py-4 sm:py-5 bg-gradient-to-r from-gray-50 to-gray-100 text-xs sm:text-sm text-gray-500 text-center border-t border-gray-100">
            <i className="ri-information-line mr-1"></i>
            最新情報は公式サイトをご確認ください。
          </div>
        </div>
        
        {/* モバイル用スクロールヒント */}
        <div className="mt-4 text-center text-sm text-gray-500 sm:hidden">
          <i className="ri-arrow-left-right-line mr-1"></i>
          左右にスクロールできます
        </div>
      </div>
    </section>
  );
}